import ReservationSidebar from '../../Commun/ReservationSidebar';
import ReservationHeader from '../../Commun/ReservationHeader';
import { useProperty } from '../../../PropertyContext';
import { useEffect, useState } from 'react';
import { GetResAgentList, GetResCorporatedetail, Property, ReservationMealplan, ReservationRateCode, ReservationRateCodeList } from '../../../Services/Service';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRoomAvailability } from '../../../Redux/Slices/ReservationRoomAval.slice';
import { fetchReservationMasters } from '../../../Redux/Slices/reservationMasterSlice';
import { editOperaStay, editOperaRoom, editOperaGuest, editOperaAdditional } from '../../../Redux/Slices/Reseroperaeditslice';
import swal from "sweetalert";
import StayDetails from './Staydetails';
import RoomRates from './RoomRates';
import GuestDetails from './GuestDetails';
import AdditionalBilling from './Additionalbilling';
import { fetchVoucherDetails } from '../../../Redux/Slices/reservationVoucherSlice';


export const ReserOperaBookingEdit = () => {
    const { selectedProperty } = useProperty();
    const location = useLocation();
    const { header, rooms, bookingInfo } = location.state || {};
    const dispatch = useDispatch();

    const BONRESID = bookingInfo?.BONRESID || "";

    // ── Stay Details ──
    const [arrivalDate, setArrivalDate] = useState("");
    const [departureDate, setDepartureDate] = useState("");
    const [nights, setNights] = useState(0);
    const [rateTypeCode, setRateTypeCode] = useState("Property");
    const [rateCodes, setRateCodes] = useState([]);
    const [agentList, setAgentList] = useState([]);
    const [selectedAgentId, setSelectedAgentId] = useState("");
    const [corporateList, setCorporateList] = useState([]);
    const [selectedCorporateId, setSelectedCorporateId] = useState("");
    const [isStayEditMode, setIsStayEditMode] = useState(false);
    const [originalStayData, setOriginalStayData] = useState({
        arrivalDate: "", departureDate: "", rateTypeCode: "",
        selectedAgentId: null, selectedCorporateId: null,
    });

    // ── Room & Rates ──
    const [roomRows, setRoomRows] = useState([]);
    const [mealplan, setMealplan] = useState([]);
    const [ratecode, setRatecode] = useState([]);
    const [Pms, setPMS] = useState();
    const [isEditMode, setIsEditMode] = useState(false);
    const [originalRoomRows, setOriginalRoomRows] = useState([]);

    // ── Guest Details ──
    const [salutation, setSalutation] = useState("Mr.");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phone, setPhone] = useState("");
    const [countryCode, setCountryCode] = useState("+91");
    const [isGuestEditMode, setIsGuestEditMode] = useState(false);
    const [originalGuestData, setOriginalGuestData] = useState({});

    // ── Additional & Billing ──
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [gstNumber, setGstNumber] = useState("");
    const [gstCompanyName, setGstCompanyName] = useState("");
    const [gstAddress, setGstAddress] = useState("");
    const [billingInstruction, setBillingInstruction] = useState("");
    const [marketSegment, setMarketSegment] = useState("");
    const [businessSource, setBusinessSource] = useState("");
    const [guaranteeCode, setGuaranteeCode] = useState("");
    const [bookingComment, setBookingComment] = useState("");
    const [paymentComment, setPaymentComment] = useState("");
    const [isBillingEditMode, setIsBillingEditMode] = useState(false);
    const [originalBillingData, setOriginalBillingData] = useState({});

    // Redux masters
    const { marketSegments, businessSources, guaranteeCodes } = useSelector((state) => state.reservationMasters);

    // ── useEffects ──

    useEffect(() => {
        if (selectedProperty?.PropertyID) {
            dispatch(fetchReservationMasters(selectedProperty.PropertyID));
        }
    }, [selectedProperty, dispatch]);

    useEffect(() => {
        if (!header && !bookingInfo) return;

        setArrivalDate(parseDate(bookingInfo?.CheckInDate) || "");
        setDepartureDate(parseDate(bookingInfo?.CheckOutDate) || "");
        setRateTypeCode(header?.RateCode || "");

        if (header?.RateCode === "Travel Agent") setSelectedAgentId(Number(header?.RateCodeID));
        if (header?.RateCode === "Corporate") setSelectedCorporateId(Number(header?.RateCodeID));

        setSalutation(header?.Title || "Mr.");
        setFirstName(header?.FirstName || "");
        setLastName(header?.LastName || "");
        setPhone(header?.Telephone || "");
        setEmail(header?.Email || "");
        setAddress(header?.Address || "");
        setCity(header?.City || "");
        setCountry(header?.Country || "");
        setState(header?.State || "");
        setCompanyName(bookingInfo?.CompanyName || "");
        setGstNumber(header?.RegTax_Number || "");
        setGstCompanyName(header?.Reg_CompName || "");
        setGstAddress(header?.RegCom_Address || "");
        setBillingInstruction(bookingInfo?.BillingInstructions || "");
        setMarketSegment(bookingInfo?.MarketSegment || "");
        setBusinessSource(bookingInfo?.BusinessSource || "");
        setGuaranteeCode(bookingInfo?.GuaranteeCodes || "");

        try { setBookingComment(JSON.parse(header?.BookingComment)?.[0]?.BookingComment || ""); }
        catch { setBookingComment(""); }

        try { setPaymentComment(JSON.parse(header?.PaymentComment)?.[0]?.PaymentComment || ""); }
        catch { setPaymentComment(""); }

    }, [header, bookingInfo]);

    useEffect(() => {
        if (!rooms || rooms.length === 0) return;
        setRoomRows(rooms.map((room) => ({
            RoomID: room.RoomID || room.RoomId || 0,
            RoomName: room.RoomName,
            mealPlanID: room.MeelPlanCode || "",
            ratePlanID: room.RatePlanCode || "",
            mealPlanName: room.MeelPlan,
            ratePlanName: room.RatePlan,
            adults: room.adults || 0,
            child: room.Child || 0,
            extraBed: 0,
            amount: room.RoomRate || "",
            tax: String(room.Tax || ""),
            taxRate: room.TaxRate || "",
            total: room.NetAmount || "",
        })));
    }, [rooms]);

    useEffect(() => {
        if (arrivalDate && departureDate) {
            const arrival = new Date(arrivalDate);
            const departure = new Date(departureDate);
            const diffTime = departure - arrival;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            setNights(diffDays > 0 ? diffDays : 0);
        }
    }, [arrivalDate, departureDate]);

     useEffect(() => {
        const FetchPMS = async () => {
          if (!selectedProperty?.PropertyID) return;
          try {
            const result = await Property();
            const matched = result.find(p => p.PropertyID === selectedProperty.PropertyID);
            setPMS(matched || null);
          } catch (error) {
            console.log("error fetch PMS", error);
          }
        };
        FetchPMS();
      }, [selectedProperty]);

    useEffect(() => {
        const fetchRateCodestype = async () => {
            try {
                const res = await ReservationRateCode();
                if (res) setRateCodes(res);
            } catch (error) { console.error("Error fetching rate codes:", error); }
        };
        fetchRateCodestype();
    }, []);

    useEffect(() => {
        const FetchAgentName = async () => {
            try {
                const result = await GetResAgentList(selectedProperty?.PropertyID);
                if (Array.isArray(result)) {
                    setAgentList(result.filter(a => a.TA_Name && a.AgentID));
                }
            } catch (error) { console.log("error get Agent Name", error); }
        };
        FetchAgentName();
    }, [selectedProperty]);

    useEffect(() => {
        const FetchCorporateDetail = async () => {
            try {
                const result = await GetResCorporatedetail(selectedProperty?.PropertyID);
                if (Array.isArray(result)) {
                    setCorporateList(result.filter(corp => corp.CorporateID && corp.TA_Name));
                }
            } catch (error) { console.log("error get corporate detail", error); }
        };
        FetchCorporateDetail();
    }, [selectedProperty]);

    useEffect(() => {
        const FetchMealplan = async () => {
            try {
                const result = await ReservationMealplan(selectedProperty?.PropertyID);
                if (Array.isArray(result)) setMealplan(result);
            } catch (error) { console.log("error get meal plan", error); }
        };
        if (selectedProperty?.PropertyID) FetchMealplan();
    }, [selectedProperty]);

    useEffect(() => {
        const fetchRatecode = async () => {
            try {
                const result = await ReservationRateCodeList(selectedProperty?.PropertyID);
                if (Array.isArray(result)) setRatecode(result);
            } catch (error) { console.log("error get rate code", error); }
        };
        if (selectedProperty?.PropertyID) fetchRatecode();
    }, [selectedProperty]);

    // ── Helpers ──

    const parseDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (!isNaN(d.getTime())) {
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
        }
        const months = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
        const parts = dateStr.trim().split(" ");
        if (parts.length === 3) {
            const day = parseInt(parts[0], 10);
            const month = months[parts[1]];
            const year = parseInt(`20${parts[2]}`, 10);
            return `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
        }
        return "";
    };

    const updateRoomRow = (index, field, value) => {
        setRoomRows(prev =>
            prev.map((row, i) => {
                if (i !== index) return row;
                const updatedRow = { ...row, [field]: value };
                const amount = Number(updatedRow.amount || 0);
                const tax = Number(updatedRow.tax || 0);
                const taxRate = (amount * tax) / 100;
                return { ...updatedRow, taxRate: taxRate.toFixed(2), total: (amount + taxRate).toFixed(2) };
            })
        );
    };

    // ── Totals ──
    const totalAmount = roomRows.reduce((sum, row) => sum + Number(row.amount || 0), 0);
    const totalTaxAmount = roomRows.reduce((sum, row) => sum + Number(row.taxRate || 0), 0);
    const totalRowAmount = roomRows.reduce((sum, row) => sum + Number(row.total || 0), 0);
    const totalPayment = totalAmount * Number(nights || 0);
    const totalTax = totalTaxAmount * Number(nights || 0);
    const grandTotal = totalRowAmount * Number(nights || 0);

    // ── Handlers ──

    const handleSearchRoom = async () => {
        const RateCodeID =
            rateTypeCode === "Travel Agent"
                ? selectedAgentId || 0
                : rateTypeCode === "Corporate"
                    ? selectedCorporateId || 0
                    : 0;

        const result = await dispatch(
            fetchRoomAvailability({
                PropertyID: selectedProperty?.PropertyID,
                CheckInDate: arrivalDate,
                CheckoutDate: departureDate,
                RateTypeCode: rateTypeCode,
                RateCodeID,
            })
        );

        // console.log("API Result =>", result);

        const availabilityRooms = Array.isArray(result?.payload)
            ? result.payload
            : result?.payload?.Data || [];

        // console.log("Availability Rooms =>", availabilityRooms);
        // console.log("Current Room Rows =>", roomRows);

        const roomRequiredCount = roomRows.reduce((acc, room) => {
            const roomId = Number(room.RoomID);

            acc[roomId] = (acc[roomId] || 0) + 1;

            return acc;
        }, {});

        // console.log("Required Room Count =>", roomRequiredCount);

        let isAvailable = true;

        Object.entries(roomRequiredCount).forEach(([roomId, requiredCount]) => {
            const availableRoom = availabilityRooms.find(
                (r) => Number(r.RoomID) === Number(roomId)
            );

            // console.log("=================================");
            // console.log("Checking RoomID:", roomId);
            // console.log("Required Count:", requiredCount);
            // console.log("Matched Room:", availableRoom);
            // console.log(
            //     "RoomID Match:",
            //     availableRoom
            //         ? Number(availableRoom.RoomID) === Number(roomId)
            //         : false
            // );

            if (!availableRoom) {
                console.log(`❌ RoomID ${roomId} not found in API response`);
                isAvailable = false;
                return;
            }

            // console.log(
            //     `Available Count: ${availableRoom.count} | Required Count: ${requiredCount}`
            // );

            if (Number(availableRoom.count) < Number(requiredCount)) {
                console.log("❌ Not Enough Rooms Available");
                isAvailable = false;
            } else {
                console.log("✅ Room Available");
            }
        });

        // console.log("Final Availability Status =>", isAvailable);

        swal(
            isAvailable ? "Room Available" : "No Room Available",
            "",
            isAvailable ? "success" : "error"
        );
    };

    // ── Stay Handlers ──
    const handleStayEdit = (e) => {
        e.preventDefault();
        setOriginalStayData({ arrivalDate, departureDate, rateTypeCode, selectedAgentId, selectedCorporateId });
        setIsStayEditMode(true);
    };
    const handleStayCancel = () => {
        setArrivalDate(originalStayData.arrivalDate);
        setDepartureDate(originalStayData.departureDate);
        setRateTypeCode(originalStayData.rateTypeCode);
        setSelectedAgentId(originalStayData.selectedAgentId);
        setSelectedCorporateId(originalStayData.selectedCorporateId);
        setIsStayEditMode(false);
    };
    const handleStayDone = async () => {
        const postData = {
            BONRESID: BONRESID,
            CheckInDate: arrivalDate,
            CheckOutDate: departureDate,
            Remarks: "Guest requested date change",
        };
        // console.log("stay payload", postData);
        // console.log("Payload JSON:", JSON.stringify(postData, null, 2));
        const result = await dispatch(editOperaStay(postData));
        if (editOperaStay.fulfilled.match(result)) {
            swal("Stay Details Updated!", "Stay details saved successfully.", "success");
            dispatch(fetchVoucherDetails(BONRESID));
            setIsStayEditMode(false);
        } else {
            swal("Error!", result.payload || "Failed to update stay details.", "error");
        }
    };

    // ── Room Handlers ──
    const handleEdit = () => {
        setOriginalRoomRows(JSON.parse(JSON.stringify(roomRows)));
        setIsEditMode(true);
    };
    const handleCancel = () => {
        setRoomRows(originalRoomRows);
        setIsEditMode(false);
    };
    const handleRoomDone = async () => {
        const postData = {
            BONRESID: BONRESID,
            Remarks: "Guest upgraded room",
            RoomDetails: roomRows.map((row) => ({
                RoomID: row.RoomID,
                RatePlanID: row.ratePlanID || "",
                MealPlanID: row.mealPlanID || "",
                TotalRoom: 1,
                RoomRate: row.amount || 0,
                Adults: row.adults || 0,
                Child: row.child || 0,
                Tax: row.tax || 0,
                TaxRate: row.taxRate || 0,
                NetAmount: row.total || 0,
            })),
        };
        
        const result = await dispatch(editOperaRoom(postData));
        if (editOperaRoom.fulfilled.match(result)) {
            swal("Room Details Updated!", "Room details saved successfully.", "success");
            dispatch(fetchVoucherDetails(BONRESID));
            setIsEditMode(false);
        } else {
            swal("Error!", result.payload || "Failed to update room details.", "error");
        }
    };

    // ── Guest Handlers ──
    const handleGuestEdit = () => {
        setOriginalGuestData({ salutation, firstName, lastName, countryCode, phone });
        setIsGuestEditMode(true);
    };
    const handleGuestCancel = () => {
        setSalutation(originalGuestData.salutation);
        setFirstName(originalGuestData.firstName);
        setLastName(originalGuestData.lastName);
        setCountryCode(originalGuestData.countryCode);
        setPhone(originalGuestData.phone);
        setIsGuestEditMode(false);
    };
    const handleGuestDone = async () => {
        const postData = {
            BONRESID: BONRESID,
            Remarks: "Guest details updated",
            GuestDetails: [
                {
                    Title: salutation || "",
                    FirstName: firstName || "",
                    MiddleName: "",
                    LastName: lastName || "",
                    EMailAddress: email || "",
                    Address: address || "",
                    MobileNumber: phone || "",
                    Country: country || "",
                    State: state || "",
                    City: city || "",
                    RatePlanID: "",
                    Mcod: "",
                },
            ],
        };
        
        const result = await dispatch(editOperaGuest(postData));
        if (editOperaGuest.fulfilled.match(result)) {
            swal("Guest Details Updated!", "Guest details saved successfully.", "success");
            dispatch(fetchVoucherDetails(BONRESID));
            setIsGuestEditMode(false);
        } else {
            swal("Error!", result.payload || "Failed to update guest details.", "error");
        }
    };

    // ── Billing Handlers ──
    const handleBillingEdit = () => {
        setOriginalBillingData({
            email, address, city, country, state, companyName,
            gstNumber, gstCompanyName, gstAddress, billingInstruction,
            marketSegment, businessSource, guaranteeCode, bookingComment, paymentComment,
        });
        setIsBillingEditMode(true);
    };
    const handleBillingCancel = () => {
        setEmail(originalBillingData.email || "");
        setAddress(originalBillingData.address || "");
        setCity(originalBillingData.city || "");
        setCountry(originalBillingData.country || "");
        setState(originalBillingData.state || "");
        setCompanyName(originalBillingData.companyName || "");
        setGstNumber(originalBillingData.gstNumber || "");
        setGstCompanyName(originalBillingData.gstCompanyName || "");
        setGstAddress(originalBillingData.gstAddress || "");
        setBillingInstruction(originalBillingData.billingInstruction || "");
        setMarketSegment(originalBillingData.marketSegment || "");
        setBusinessSource(originalBillingData.businessSource || "");
        setGuaranteeCode(originalBillingData.guaranteeCode || "");
        setBookingComment(originalBillingData.bookingComment || "");
        setPaymentComment(originalBillingData.paymentComment || "");
        setIsBillingEditMode(false);
    };
    const handleBillingDone = async () => {
        const postData = {
            BONRESID: BONRESID,
            Remarks: "Company details updated",
            CompanyDetails: {
                CompanyName: companyName || "",
                MarketSegment: marketSegment || "",
                RegistrationNumber: gstNumber || "",
                RegistrationCompanyName: gstCompanyName || "",
                RegistrationCompanyAddress: gstAddress || "",
            },
        };
        console.log("Payload JSON:", JSON.stringify(postData, null, 2));
        const result = await dispatch(editOperaAdditional(postData));
        if (editOperaAdditional.fulfilled.match(result)) {
            swal("Billing Details Updated!", "Additional & billing details saved successfully.", "success");
            dispatch(fetchVoucherDetails(BONRESID));
            setIsBillingEditMode(false);
        } else {
            swal("Error!", result.payload || "Failed to update billing details.", "error");
        }
    };

    return (
        <>
            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">

                            <div className="d-flex justify-content-between align-items-end mb-4">
                                <h2 className="fw-bold mb-1" style={{ fontSize: 24, letterSpacing: "-0.02em" }}>
                                    Reservation Opera Edit Booking Details
                                </h2>
                            </div>

                            <form>
                                {/* ── Stay Details ── */}
                                <StayDetails
                                    isStayEditMode={isStayEditMode}
                                    arrivalDate={arrivalDate}
                                    setArrivalDate={setArrivalDate}
                                    departureDate={departureDate}
                                    setDepartureDate={setDepartureDate}
                                    nights={nights}
                                    rateTypeCode={rateTypeCode}
                                    setRateTypeCode={setRateTypeCode}
                                    rateCodes={rateCodes}
                                    agentList={agentList}
                                    selectedAgentId={selectedAgentId}
                                    setSelectedAgentId={setSelectedAgentId}
                                    corporateList={corporateList}
                                    selectedCorporateId={selectedCorporateId}
                                    setSelectedCorporateId={setSelectedCorporateId}
                                    handleStayEdit={handleStayEdit}
                                    handleStayCancel={handleStayCancel}
                                    handleStayDone={handleStayDone}
                                    handleSearchRoom={handleSearchRoom}
                                />

                                {/* ── Room & Rates ── */}
                                <RoomRates
                                    isEditMode={isEditMode}
                                    roomRows={roomRows}
                                    updateRoomRow={updateRoomRow}
                                    mealplan={mealplan}
                                    ratecode={ratecode}
                                    Pms={Pms}
                                    nights={nights}
                                    handleEdit={handleEdit}
                                    handleCancel={handleCancel}
                                    handleRoomDone={handleRoomDone}
                                    totalAmount={totalAmount}
                                    totalTaxAmount={totalTaxAmount}
                                    totalRowAmount={totalRowAmount}
                                    totalPayment={totalPayment}
                                    totalTax={totalTax}
                                    grandTotal={grandTotal}
                                />

                                {/* ── Guest Details ── */}
                                <GuestDetails
                                    isGuestEditMode={isGuestEditMode}
                                    salutation={salutation}
                                    setSalutation={setSalutation}
                                    firstName={firstName}
                                    setFirstName={setFirstName}
                                    lastName={lastName}
                                    setLastName={setLastName}
                                    countryCode={countryCode}
                                    setCountryCode={setCountryCode}
                                    phone={phone}
                                    setPhone={setPhone}
                                    email={email} setEmail={setEmail}
                                    address={address} setAddress={setAddress}
                                    city={city} setCity={setCity}
                                    country={country} setCountry={setCountry}
                                    state={state} setState={setState}
                                    handleGuestEdit={handleGuestEdit}
                                    handleGuestCancel={handleGuestCancel}
                                    handleGuestDone={handleGuestDone}
                                />

                                {/* ── Additional & Billing ── */}
                                <AdditionalBilling
                                    isBillingEditMode={isBillingEditMode}
                                    companyName={companyName} setCompanyName={setCompanyName}
                                    gstNumber={gstNumber} setGstNumber={setGstNumber}
                                    gstCompanyName={gstCompanyName} setGstCompanyName={setGstCompanyName}
                                    gstAddress={gstAddress} setGstAddress={setGstAddress}
                                    billingInstruction={billingInstruction} setBillingInstruction={setBillingInstruction}
                                    marketSegment={marketSegment} setMarketSegment={setMarketSegment}
                                    businessSource={businessSource} setBusinessSource={setBusinessSource}
                                    guaranteeCode={guaranteeCode} setGuaranteeCode={setGuaranteeCode}
                                    bookingComment={bookingComment} setBookingComment={setBookingComment}
                                    paymentComment={paymentComment} setPaymentComment={setPaymentComment}
                                    marketSegments={marketSegments}
                                    businessSources={businessSources}
                                    guaranteeCodes={guaranteeCodes}
                                    handleBillingEdit={handleBillingEdit}
                                    handleBillingCancel={handleBillingCancel}
                                    handleBillingDone={handleBillingDone}
                                />
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};